
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1966.41 1966.41"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"M514.4 649.84v787.52L279 889.25zM668.13 991.56l261.26-266.6v-272.4H668.13zM668.13 1196v334.31h261.26v-432.95l-69.28-98.62zM1267.71 889.25l426.52-436.7h-298.72l-427.05 436.7 453.69 641.06h298.32z"}})])])
          )
        }
      }
    